// extracted by mini-css-extract-plugin
export default {"dialog":"ConfirmView_dialog__Ocz1n","title":"ConfirmView_title__GMa8W","dialogContent":"ConfirmView_dialogContent__e5OF7","button":"ConfirmView_button__biLhM"};